"use client";

import {
  useAssignSettingMobileLoggedOutNavUpdate,
  useIsEligibleForMobileLoggedOutNavUpdate,
  useShouldShowUpdatedMobileSearch,
} from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutNavUpdate";
import React, { useEffect } from "react";

import { useHeaderState } from "../../useHeaderState";

export const HideHeaderWhenSearchIsOpenForLoggedOutNavUpdate: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { isShowingMobileSearch } = useHeaderState();
  const shouldShowUpdatedMobileSearch = useShouldShowUpdatedMobileSearch();
  return shouldShowUpdatedMobileSearch && isShowingMobileSearch
    ? null
    : children;
};

export const AssignLoggedOutNavUpdate: React.FC = () => {
  const assignSettingMobileLoggedOutNavUpdate =
    useAssignSettingMobileLoggedOutNavUpdate();

  const isEligibleForMobileLoggedOutNavUpdate =
    useIsEligibleForMobileLoggedOutNavUpdate();

  useEffect(() => {
    if (isEligibleForMobileLoggedOutNavUpdate) {
      assignSettingMobileLoggedOutNavUpdate();
    }
  }, [
    assignSettingMobileLoggedOutNavUpdate,
    isEligibleForMobileLoggedOutNavUpdate,
  ]);
  return null;
};
